<template>
  <div class="dashboard-main-content">

    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-12">
          <div class="form-box" v-if="bookingList !== null">
            <div class="form-title-wrap">
              <div class="d-flex align-items-center justify-content-between">
                <h3 class="title">Rezervasyonlar {{getFilterStatus()}}</h3>
              </div>
            </div>
            <div class="col mb-4">
              <div class="container-fluid">
              <div class="row" >
                <div class="input-box">
                  <label class="label-text">Başlangıç Tarihi</label>
                  <input class="form-control" v-model="startDate" id="startDate" type="date" placeholder="">
                </div>
                <div class="input-box ml-2">
                  <label class="label-text">Bitiş Tarihi</label>
                  <input class="form-control" v-model="endDate" id="endDate" type="date" placeholder="">
                </div>
                <div class="input-box ml-2">
                  <label class="label-text" style="opacity: 0">.</label>
                  <button class="btn theme-btn form-control" @click="update"
                          style="padding-bottom: 0px !important;padding-top: 0px !important;" id="update" type="button">
                    Güncelle</button>
                </div>
              </div>
              </div>
            </div>
            <v-app>
              <v-data-table
                  :headers="headers"
                  :items="bookingList"
                  :items-per-page="100"
                  class="elevation-1"
                  :search="search"
                  :custom-filter="filterBookings"
              >
<!--                <template v-slot:top>-->
<!--                  <v-text-field-->
<!--                      v-model="search"-->
<!--                      label="Arama"-->
<!--                      class="mx-4"/>-->
<!--                </template>-->

                <template v-slot:item.id="{ item }">
                  <tr>
                    <th><a :href="basePath+'/bookings/'+item.id">#{{item.id}}</a></th>
                  </tr>
                </template>

                <template v-slot:item.bookingNumber="{ item }">
                  <tr>
                    {{ item.bookingNumber }}
                  </tr>
                </template>

                <template v-slot:item.contactName="{ item }">
                  <tr>
                    {{ item.contactName }}
                  </tr>
                </template>

                <template v-slot:item.passengerCount="{ item }">
                  <tr>
                    {{ item.passengerCount }}
                  </tr>
                </template>

                <template v-slot:item.passengersCountry="{ item }" >
                  <tr>
                    {{ getPassengersCountry(item) }}
                  </tr>
                </template>

                <template v-slot:item.sail.sailDate="{ item }">
                  <tr>
                    {{ item.sail.sailDate | ddMMyyyy }}
                  </tr>
                </template>
                <template v-slot:item.cabinNumbers="{ item }">
                  <tr>
                    {{ getBookingCruiseRoom(item) }}
                  </tr>
                </template>

                <template v-slot:item.totalPrice="{ item }">
                  <tr>
                    {{ item.totalPrice }} €
                  </tr>
                </template>

                <template v-slot:item.agencyName="{ item }">
                  <tr>
                    {{ item.agencyName }}
                  </tr>
                </template>

                <template v-slot:item.bookingStatus="{ item }">
                  <tr>
                    <reservation-status :booking-status="item.bookingStatus"></reservation-status>
                  </tr>
                </template>

                <template v-slot:item.contactFormConsent="{ item }">
                  <tr>
                    <span v-if="item.contactFormConsent" class="badge badge-success py-1 px-2">Onaylandı</span>
                    <span v-else class="badge badge-warning py-1 px-2">Onaylanmadı</span>
                  </tr>
                </template>

                <template v-slot:item.createDate="{ item }">
                  <tr>
                    {{ item.createDate | ddMMyyyyHHmmSS }}
                  </tr>
                </template>
                <template v-slot:item.confirmationStatus="{ item }">
                  <th>
                    <div v-if="item.confirmed && (item.bookingStatus === 'OK' || item.bookingStatus === 'PARTIALLY_PAID')">
                      <span class="badge badge-success py-1 px-2">Onaylandı</span>
                    </div>
                    <div class="table-content" v-else-if="agencyMap[userListMap[item.agentId].agencyId].agreementType === 'cash'
                    && !item.confirmed && (item.bookingStatus === 'OK' || item.bookingStatus === 'PARTIALLY_PAID')">
                      <button @click="confirmBooking(item.id)" style="color: white; font-size: 12px"
                              class="theme-btn theme-btn-small"
                              data-toggle="tooltip" data-placement="top" title="" data-original-title="Edit">
                        Onayla
                      </button>
                    </div>
<!--                    <div v-if="item.confirmed && (item.bookingStatus === 'OK' || item.bookingStatus === 'PARTIALLY_PAID')">-->
<!--                      <reservation-status :booking-status="item.bookingStatus"></reservation-status>-->
<!--                    </div>-->
                  </th>
                </template>

                <template v-slot:item.detail="{ item }">
                  <th>
                    <div class="table-content">
                      <a style="color: white" :href="basePath+'/bookings/'+item.id" class="theme-btn theme-btn-small" data-toggle="tooltip" data-placement="top" title="" data-original-title="Edit">
                        <i class="la la-edit"></i>
                      </a>
                    </div>
                  </th>
                </template>

              </v-data-table>
            </v-app>
          </div>
        </div>
      </div>
    </div>
    <div class="loader col-lg-12 mt-5" id="loader" v-if="bookingList === null">
    </div>
  </div>
</template>

<script>
import ReservationStatus from "../common/ReservationStatus";
import {dd_MM_yyyy_tire, yyyy_MM_dd_tire} from "../../util/filters";
import messagePopupManager from "../../util/messagePopupManager";

export default {
  name: "AgencyBookingConfirmationList",
  components: {ReservationStatus},
  data () {
    return {
      search: '',
      headers: [],
      propBookingList: null,
      startDate: yyyy_MM_dd_tire(new Date()),
      endDate: yyyy_MM_dd_tire(new Date(new Date().getTime() + 86400000))
    }
  },
  // props : {
  //   propBookingList: null,
  // },
  beforeCreate() {
    this.$store.dispatch("loadCruiseRoomList", this.$store.getters.getCruise.id);
  },
  mounted() {
    this.bookingList = null;
    this.$store.dispatch("loadBookingListBetween", { startDate: this.startDate, endDate: this.endDate}).then((response) => {
      this.propBookingList = response;
    })

    let headers =this.headers;
    headers.push({
      text: '#',
      align: 'start',
      sortable: true,
      value: 'id',
    })

    headers.push({
      text: 'Rezervasyon No',
      sortable: true,
      value: 'bookingNumber',
    })

    headers.push({
      text: 'İletişim Kişisi',
      sortable: true,
      value: 'contactName'
    })

    headers.push({
      text: 'Yolcu Sayısı',
      sortable: true,
      value: 'passengerCount',
    })

    if( this.projectName === 'miray'){
      headers.push({
        text: 'Yolcu Ülke',
        sortable: true,
        value: 'passengersCountry',
      })

    }
    headers.push({
      text: 'Sefer Tarihi',
      sortable: true,
      value: 'sail.sailDate',
    })

    headers.push({
      text: 'Kabin Numarası',
      sortable: true,
      value: 'cabinNumbers',
    })

    headers.push({
      text: 'Fiyat',
      sortable: true,
      value: 'totalPrice',
    })

    headers.push({
      text: 'Acente',
      sortable: true,
      value: 'agencyName',
    })

    headers.push({
      text: 'Durum',
      sortable: true,
      value: 'bookingStatus',
    })

    // headers.push({
    //   text: 'İletişim izni',
    //   sortable: true,
    //   value: 'contactFormConsent',
    // })

    headers.push({
      text: 'Rezervasyon Tarihi',
      sortable: true,
      value: 'createDate',
    })

    headers.push({
      text: 'Onay Durumu',
      value: 'confirmationStatus',
    })

    headers.push({
      text: 'Detay',
      value: 'detail',
    })
  },
  computed:{
    bookingList:{
      get(){
        let bookingList = this.propBookingList;
        if(bookingList === null){
          return null;
        }
        if(this.agencyMap !== undefined && this.userListMap !== undefined &&
            this.agencyMap !== null && this.userListMap !== null) {
          bookingList.forEach(booking => {
            let user = this.userListMap[booking.agentId];
            if(user !== undefined) {
              let agency = this.agencyMap[user.agencyId];
              if(agency !== undefined) {
                booking.agencyName = agency.name;
              }
            }
          })
        }

        if(this.filterStatus === null) {
          return bookingList.filter(booking => {
            return booking.bookingStatus !== "PENDING";
          });
          // return bookingList;
        }

        return bookingList.filter(booking => {
          return booking.bookingStatus === this.filterStatus;
        });
      }
    },
    agencyMap:{
      get(){
        return this.$store.getters.getAgencyListMap;
      }
    },
    basePath:{
      get(){
        return this.$store.getters.getBasePath
      }
    },
    userListMap:{
      get(){
        return this.$store.getters.getUserListMap;
      }
    },
    filterStatus:{
      get() {
        let params = (new URL(document.location)).searchParams;
        return params.get("status");
      }
    },
    cruiseRooms:{
      get(){
        return this.$store.getters.getCruiseRoomList;
      }
    },
    projectName:{
      get() {
        return this.$store.getters.getProjectName;
      }
    }
  },
  methods:{
    filterBookings (value, search, item) {
      if(value == null || search == null){
        return false;
      }

      return value.toString().toLowerCase().indexOf(search.toLowerCase()) !== -1
    },
    show(){
      this.$store.commit("setBooking",{id:null});
    },
    getBookingCruiseRoom(booking){
      if(this.cruiseRooms === null || this.cruiseRooms === undefined) return 
      let bookingCruiseRoomIdList = [];
      for(let room of booking.bookingRooms){
        bookingCruiseRoomIdList.push(room.cruiseRoomId);
      }
      let bookingRoomNumberList = [];
        for(let cruiseRoom of this.cruiseRooms) {
          for (let id of bookingCruiseRoomIdList) {
            if (id === cruiseRoom.id) {
              bookingRoomNumberList.push(cruiseRoom.roomNumber);
            }
          }
        }
      let cabinListText ="";
      for(let cabinIndex=0 ; cabinIndex < bookingRoomNumberList.length; cabinIndex++){
        if(cabinIndex+1 === bookingRoomNumberList.length){
          cabinListText += bookingRoomNumberList[cabinIndex]
        }else{
          cabinListText += bookingRoomNumberList[cabinIndex]+',';
        }
      }
      return cabinListText;
    },
    getFilterStatus(){
      switch (this.filterStatus){
        case 'OK':
          return '| Filtre: Başarılı'
        case 'PARTIALLY_PAID':
          return '| Filtre: Parçalı Ödeme'
        case 'CANCELLED':
            return '| Filtre: İptal'
        case 'CREDIT_CARD':
          return '| Filtre: Kredi Kartı'
        case 'COUPON':
          return '| Filtre: Kupon'
        case 'PENDING':
          return '| Filtre: Beklemede'
      }
      return this.filterStatus;
    },
    getPassengersCountry(booking){
      let passengers = booking.bookingPassengers;
      let countryListText = "";
      //TODO: BAD CODE BELOW :(
      for(let passengerIndex = 0; passengerIndex < passengers.length; passengerIndex++){
        if(passengers[passengerIndex].turkishCitizen){
          countryListText += 'TR';
        }else if(!passengers[passengerIndex].turkishCitizen){
          if(passengers[passengerIndex].country === null){
            countryListText += '-';
          }else{
            if(passengerIndex+1 === passengers.length){
              countryListText += passengers[passengerIndex].country
            }else{
              countryListText += passengers[passengerIndex].country + ',';
            }
          }

        }else{
          throw "unexpected passenger identity"
        }

      }
      return countryListText;
    },
    update(){
      this.$store.dispatch("loadBookingListBetween", { startDate: this.startDate, endDate: this.endDate}).then((response) => {
        this.propBookingList = response;
      })
    },
    confirmBooking(bookingId){
      this.$store.dispatch("postConfirmBooking", {bookingId}).then((response) => {
        messagePopupManager.showSuccess();
        this.update();
      })
    }
  },
}
</script>

<style scoped>

.mt-5 {
  margin-top: 20% !important;
}

.loader {
  border: 16px solid #f3f3f3; /* Light grey */
  border-top: 16px solid #2877b5; /* Blue */
  border-radius: 50%;
  width: 120px;
  height: 120px;
  animation: spin 2s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>